import {kSystemImages} from "../../../constants/images";

export default function GlossaryStarDivider() {
    // Used in ResultsQuestionsList to separate
    // questions

    // BUILD
    return(
        <div className="mt-[10px] flex items-center relative pl-[8px] pr-[16px]">
            <img className="-mr-[2px]"
                 src={kSystemImages.dividerStar}
                 style={{height: 10}}
                 alt={""}/>
            <div className={"w-full h-[1px] bg-greyLight5"}> </div>
        </div>
    );
}